module.exports = __webpack_public_path__ + "img/pengboshi02.f8b90291.png";